import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';

import { PipesModule } from '@shared/pipes/pipes.module';
import { IconComponent } from '@ui-components/components/icon/icon.component';
import { NotificationRingItemModule } from '@ui-components/components/notification-ring/components/notification-ring-item/notification-ring-item.module';

import { NotificationRingComponent } from './notification-ring.component';

@NgModule({
  declarations: [NotificationRingComponent],
  imports: [
    CommonModule,
    IconComponent,
    MatMenuModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    NotificationRingItemModule,
    PipesModule,
    MatButtonModule,
  ],
  exports: [NotificationRingComponent],
})
export class NotificationRingModule {}
